// extracted by mini-css-extract-plugin
module.exports = {"title":"OrderForm_title__2kagv","campName":"OrderForm_campName__2BTZ9","form":"OrderForm_form__2B_y7"};